import { paramsToQuery } from '@/base/MaUtils.js'
import { cacheRequest, makeRequest } from '@/base/MaRequestPooler.js'

/**
 * Search Ads Integration List
 */
export function getIntegrations() {
  return makeRequest('/sa/integrations')
}

/**
 * Returns search ads visibility score for multip app and multiple country date by date
 * @param urlParams
 * {
 *  trackIds: trackId list
 *  countryCodes: country code, string
 *  startDate: date in string format ISO_DATE_FORMAT
 *  endDate: date in string format ISO_DATE_FORMAT
 * }
 */
export function fetchSAVisibilityScoreHistory({ trackIds, countryCodes, startDate, endDate }) {
  const query = paramsToQuery({ startDate, endDate, countryCodes })
  return makeRequest(`/sa/stats/apps/scores/history?${query}`, {
    method: 'POST',
    data: trackIds,
  })
}

/**
 * Returns search ads active countries with search ads visibility score and keyword count
 * @param urlParams
 * {
 * trackId: app trackId
 * startDate: date in string format ISO_DATE_FORMAT
 * endDate: date in string format ISO_DATE_FORMAT
 * }
 */
export function fetchSACountriesWithScoreAndKwCount({ trackId, startDate, endDate }) {
  const query = paramsToQuery({ startDate, endDate })
  return cacheRequest(`/sa/stats/scores/${trackId}/countries-with-score-and-kw-count?${query}`)
}

/**
 * Exports search data by competitor.
 *
 * Path Parameters:
 * - trackId: App Track Id
 * - competitorId: Competitor App Track Id
 * - countryCode: Country code (e.g., US, BR)
 * - type: Type of export ('mutual' or 'nonmutual')
 *
 * Query Parameters:
 * - startDate: Start date of report data in ISO_DATE_FORMAT (string)
 * - endDate: End date of report data in ISO_DATE_FORMAT (string)
 * - selectedAppName: Name of the selected app
 * - competitorAppName: Name of the competitor app
 * - device: Target device type ('IPHONE', 'IPAD', 'REALITY_DEVICE', 'ANDROID')
 *
 * Optional Query Parameters (for filtering):
 * - keywordFilter: Filter for keywords
 * - minPercentage: Minimum percentage for the filter
 * - maxPercentage: Maximum percentage for the filter
 * - minPopularity: Minimum popularity for the filter
 * - maxPopularity: Maximum popularity for the filter
 * - minSearchVolume: Minimum search volume for the filter
 * - maxSearchVolume: Maximum search volume for the filter
 *
 * @param {object} urlParams - Parameters for the export function.
 * @returns {Promise<object>} Response with queryId and success status.
 */

export function exportSearchByCompetitor({ trackId, competitorId, countryCode, type, startDate, endDate, selectedAppName, competitorAppName, device, keywordFilter, minPercentage, maxPercentage, minPopularity, maxPopularity, minSearchVolume, maxSearchVolume }) {
  return makeRequest(`/sa/stats/search-by-competitor/${trackId}/competitor/${competitorId}/country/${countryCode}/export/${type}?${paramsToQuery({
    startDate,
    endDate,
    selectedAppName,
    competitorAppName,
    device,
    keywordFilter,
    minPercentage,
    maxPercentage,
    minPopularity,
    maxPopularity,
    minSearchVolume,
    maxSearchVolume,
  })}`)
}
